<template>
  <b-message type="is-warning" v-if="hasRoomMismatch" :closable="false">
    <div class="is-flex is-align-items-center is-justify-content-center">
      <span>Room changed to {{ roomName }}. Confirm change?</span>
      <button class="button is-success is-rounded" @click="updateRoom">Yes</button>
    </div>
  </b-message>
</template>

<script>
import {mapState} from "vuex";
import to from "@/lib/to";
import {EventBus, EVENTS} from "@/lib/EventBus";

export default {
  name: "QuickviewRoomMismatch",
  props: {
    monitor: {
      type: Object
    }
  },
  computed: {
    ...mapState('CentralMonitoringStore', ['roomMismatchMonitors']),
    hasRoomMismatch() {
      return this.roomMismatchMonitors.has(this.monitor.id)
    },
    roomName() {
      return (this.externalMonitor || this.monitor).patient.room.name
    }
  },
  methods: {
    async updateRoom() {
      const [err] = await to(this.$http.post(`/patient_monitors/${this.monitor.id}/update_room`))
      if (!err) {
        this.$store.commit('CentralMonitoringStore/deleteRoomMismatchMonitors', this.monitor.id)
      }
    },
    roomMismatchEvent({ monitor }) {
      if (monitor.id === this.monitor.id) {
        this.externalMonitor = monitor
      }
    }
  },
  mounted() {
    EventBus.$on(EVENTS.ROOM_MISMATCH, this.roomMismatchEvent)
  },
  unmounted() {
    EventBus.$off(EVENTS.ROOM_MISMATCH, this.roomMismatchEvent)
  },
  data() {
    return {
      externalMonitor: null
    }
  }
}
</script>

<style scoped lang="scss">
  button {
    font-size: 12px;
    margin-left: 10px;
  }
</style>